// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a2c3a6a7","455":"2a55d2c9","977":"a5a7fb53"}[chunkId] + ".chunk.js";
};